import { inject, Injectable, InjectionToken } from '@angular/core';
import { IMatchResult, ProductConfigurationConfigurable } from '../product-configuration-configurable';
import { Attribute } from '@df/catalog/attribute/attribute';
import { IProductDataV3, Product } from '@df/catalog/product/product';
export const VALUE_TOKEN = new InjectionToken<number>('PRODUCT_CONFIGURABLE_OPTION_VALUE_TOKEN');
export const ATTRIBUTE_TOKEN = new InjectionToken<Attribute>('PRODUCT_CONFIGURABLE_OPTION_ATTRIBUTE_TOKEN');

@Injectable()
export class ProductConfigurationConfigurableOptionValue {
    private stateError: string | undefined;

    /**
     * Option value
     */
    readonly value = inject(VALUE_TOKEN);

    /**
     * Option attribute
     */
    readonly attribute = inject(ATTRIBUTE_TOKEN);

    /**
     * Services
     */
    readonly productConfiguration = inject(ProductConfigurationConfigurable);

    constructor() {
        this.productConfiguration.selection$.subscribe(() => (this._match = undefined));
    }

    /**
     * Match cache
     */
    private _match?: IMatchResult;

    get error() {
        return this.stateError;
    }

    get product(): Product<IProductDataV3> | undefined {
        if (!this._match) {
            this._match = this.productConfiguration.match([this.attribute.id], {
                ...this.productConfiguration.selection$.value,
                [this.attribute.id]: this.value
            });
        }
        return this._match.bestMatch;
    }

    /**
     * Pick option value
     */
    pick() {
        this.productConfiguration.select(this.attribute.id, this.value);
    }

    /**
     * Check if option value is picked
     */
    isPicked() {
        return this.productConfiguration.isSelected(this.attribute.id, this.value);
    }

    setStateError(error: string | undefined) {
        this.stateError = error;
    }
}
